import { render, staticRenderFns } from "./addAnswerComponent.vue?vue&type=template&id=78a04b02&scoped=true"
import script from "./addAnswerComponent.vue?vue&type=script&lang=js"
export * from "./addAnswerComponent.vue?vue&type=script&lang=js"
import style0 from "./addAnswerComponent.vue?vue&type=style&index=0&id=78a04b02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a04b02",
  null
  
)

export default component.exports